var React = require('react');

function DownCaret (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#5f6062","d":"M7.9,13c0-0.1,0.1-0.3,0.2-0.4l0.8-0.8c0.1-0.1,0.2-0.2,0.4-0.2s0.3,0.1,0.4,0.2l6.3,6.3l6.3-6.3c0.1-0.1,0.2-0.2,0.4-0.2\n\tc0.1,0,0.3,0.1,0.4,0.2l0.8,0.8c0.1,0.1,0.2,0.2,0.2,0.4s-0.1,0.3-0.2,0.4l-7.5,7.5C16.1,20.9,16,21,15.9,21c-0.1,0-0.3-0.1-0.4-0.2\n\tL8,13.4C7.9,13.3,7.9,13.1,7.9,13z"}));
}

DownCaret.defaultProps = {"width":"30px","height":"30px","viewBox":"0 0 30 30","preserveAspectRatio":"xMidYMid"};

module.exports = DownCaret;

DownCaret.default = DownCaret;
